const fakeCarrierData = {
  carrier_code: 'TPS123456',
  name: 'Nom du Transporteur',
  establishment_postcode: '75002',
  establishment_city: 'Paris',
  establishment_phone1: '01 23 45 67 80',
  establishment_phone2: '01 98 76 54 33',
  establishment_email: 'contact@transporteur.fr',
  establishment_address1: '15 Rue du Transporteur',
  establishment_address2: 'Bâtiment B',
  establishment_country: 'France',
  establishment_contact: 'Pierre Moreau',
  establishment_fax: '01 23 45 67 81',
  billing_name: 'Nom de Facturation Transporteur',
  billing_postcode: '33001',
  billing_city: 'Bordeaux',
  billing_phone1: '05 67 89 01 24',
  billing_phone2: '05 32 10 98 77',
  billing_email: 'facturation@transporteur.fr',
  billing_address1: '78 Rue de la Facturation',
  billing_address2: 'Appartement 4',
  billing_country: 'France',
  billing_contact: 'Sophie Martin',
  billing_fax: '05 67 89 01 25',
  email_book: 'emails@transporteur.fr',
  siret_number: '987 654 321 00015',
  vat_number: 'FR98765432101',
  ape_naf_code: '4941A',
  payment_type: 'CHEQUE',
  period: 'QUINZAINE',
  vat_status: true,
  pickup_departments: '75,92,93,94',
  delivery_departments: '33,40,64',
  semi_taut: '1,true',
  porteur_taut: '',
  semi_fourgon: '',
  porteur_fourgon: '2,false',
  semi_frigo: '',
  porteur_frigo: '1,false',
  vingt_metre_cube: '',
  plateau: '',
  is_blacklisted: false,
  is_favorite: true,
};

export default fakeCarrierData;
